import mathHelper from "../Helpers/mathHelper";
import VPricingDetailBaseItem from "./VPricingDetailBaseItem";

export default class TierItem {
  constructor(item) {
    if (item === undefined) {
      this.ClientFeeAnnually = '';
      this.ClientFeePct = 0;
      this.ClientFeePerCycle = '';
      this.ClientFeePerEval = '';
      this.CreatedBy = '';
      this.CreatedOn = '';
      this.EvalFeePerEval = '';
      this.MarkedUpAnnually = '';
      this.MarkedUpFeePerCycle = '';
      this.MarkedUpFeePerEval = '';
      this.MarkUpPct = '';
      this.MarkUpPerEval = '';
      this.MarkUpPerEvalPct = '';
      this.MarkUpPerTier = 0;
      this.ModifiedBy = '';
      this.ModifiedOn = '';
      this.Name = '';
      this.NumEvalsPerCycle = 0;
      this.NumEvalsPerYear = '';
      this.PricingDetailId = '';
      this.TierId = '';
      this.TravelCostAnnually = '';
      this.TravelCostPct = '0%';
      this.TravelCostPerCycle = '';
      this.EvalFeePerCycle = '';
      this.EvalFeeAnnually = '';
      this.EvalFeePct = '';
      this.VPricingDetailBaseItem = new VPricingDetailBaseItem();
      return;
    }
    this.ClientFeePerEval = VPricingDetailBaseItem.ConvertToDecimal(item.clientFeePerEval);
    this.CreatedBy = item.createdBy;
    this.CreatedOn = item.createdOn;
    this.EvalFeePerEval = VPricingDetailBaseItem.ConvertToDecimal(item.evalFeePerEval);
    this.MarkUpPct = VPricingDetailBaseItem.ConvertToDecimal(item.markUpPct);
    this.MarkUpPerEval = item.markUpPerEval;
    this.MarkUpPerTier = item.markUpPerTier;
    this.ModifiedBy = item.modifiedBy;
    this.ModifiedOn = item.modifiedOn;
    this.Name = item.name;
    this.NumEvalsPerCycle = item.numEvalsPerCycle;
    this.PricingDetailId = item.pricingDetailId;
    this.TierId = item.tierId;
    this.TravelCostPerCycle = VPricingDetailBaseItem.ConvertToDecimal(item.travelCostPerCycle);
    this.CurrencySymbol = item.currencySymbol;
    this.NumEvalsPerYear = item.numEvalsPerYear;
  }

  calculate(pricingDetail) {
    if (this.NumEvalsPerCycle === '') this.NumEvalsPerYear = 0;

    if (this.ClientFeePct === '') this.ClientFeePct = 0;

    this.NumEvalsPerYear = this.NumEvalsPerCycle * pricingDetail.NumCyclesPerYr;
    this.ClientFeePerCycle = this.ClientFeePerEval * this.NumEvalsPerCycle;
    this.ClientFeeAnnually = this.ClientFeePerCycle * pricingDetail.NumCyclesPerYr;

    if (pricingDetail.OverrideFee) {
      this.MarkUpPct =
        parseInt(this.ClientFeePerEval) === 0
          ? 'N/A'
          : (parseFloat(pricingDetail.PricingFeeBase) / parseFloat(this.ClientFeePerEval) - 1) * 100;
    }

    this.MarkUpPerTier = (this.ClientFeePerEval * this.MarkUpPct) / 100 + this.MarkUpPerEval;
    this.MarkedUpFeePerEval = parseFloat(this.ClientFeePerEval || 0) * (parseFloat(this.MarkUpPct || 0) / 100 + 1);
    this.MarkedUpFeePerCycle = parseFloat((this.MarkedUpFeePerEval * this.NumEvalsPerCycle).toFixed(2));
    this.MarkedUpAnnually = parseFloat((this.MarkedUpFeePerEval * this.NumEvalsPerYear).toFixed(2));
    this.MarkUpPerEvalPct = mathHelper.PercentageText(this.MarkUpPerEval, this.ClientFeePerEval);

    //Evaulator fee
    this.EvalFeePerCycle = parseFloat((this.EvalFeePerEval * this.NumEvalsPerCycle).toFixed(2));
    this.EvalFeeAnnually = parseFloat((this.EvalFeePerCycle * pricingDetail.NumCyclesPerYr).toFixed(2));
    this.EvalFeePct = mathHelper.PercentageText(this.EvalFeeAnnually, this.MarkedUpAnnually);

    //Shopper travel cost
    this.TravelCostAnnually = parseFloat((this.TravelCostPerCycle * pricingDetail.NumCyclesPerYr).toFixed(2));
    this.TravelCostPct = mathHelper.PercentageText(this.TravelCostAnnually, this.MarkedUpAnnually);

  }
}
